const customer = {
  state: {
    customerId: "",
    customerName: "全部客户"
  },
  mutations: {
    SET_CUSTOMERID: (state, id) => {
      state.customerId = id;
    },
    SET_CUSOMERNAME: (state, name = "全部客户") => {
      state.customerName = name;
    }
  },
  actions: {}
};

export default customer;
